import _sfc_main from './src/tag.vue2.mjs';
export { tagEmits, tagProps } from './src/tag.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElTag = withInstall(_sfc_main);

export { ElTag, ElTag as default };
//# sourceMappingURL=index.mjs.map
